<template>
  <div>
    <!-- 以下注释都是联调时需要的 所以暂时保留！ -->
    <li class="dkillItem">
      <div v-if="activeStatus !== 8 || activeStatus !== 5" class="showtag">
        <img src="@/assets/img/activity/seconDkill/nostart1.png" alt="" />
        <van-count-down :time="timeCount" v-if="showCount">
          <template #default="timeData">
            <span>距开始: </span>
            <span class="block difcolor">{{ supplement(timeData.days) }}</span>
            <span class="colon days">天</span>
            <span class="block difcolor">{{ supplement(timeData.hours) }}</span>
            <span class="colon difcolor">:</span>
            <span class="block difcolor">{{ supplement(timeData.minutes) }}</span>
            <span class="colon difcolor">:</span>
            <span class="block difcolor">{{ supplement(timeData.seconds) }}</span>
          </template>
        </van-count-down>
      </div>
      <div class="dkillItemBox">
        <p class="dkillTitle" @click="enterDetails(cousrseData)">
          <i v-if="cousrseData.name && cousrseData.name.substr(0, 1) == '【'"></i
          >{{ cousrseData.name }}
        </p>
        <div class="TimeHours" @click="enterDetails(cousrseData)">
          <p class="Time" v-if="cousrseData.startTime">
            开课时间<span>{{ cousrseData.startTime | changeDeadLineTime }}</span
            ><em>|</em>
          </p>
          <p class="time1" v-if="(cousrseData?.isEbook) && cousrseData.productAttributeRespVOS.filter(item => item.extendAttributeName === '字数')?.[0].dataJson">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/player/ebook_icon.png" /> {{ cousrseData.productAttributeRespVOS.filter(item => item.extendAttributeName === '字数')?.[0].dataJson }}
          </p>
          <p class="hourse" v-if="cousrseData.classPeriod && !cousrseData?.isEbook">
            课时<span>{{ cousrseData.classPeriod }}</span>
          </p>
        </div>

        <!-- 教师头像 -->
        <div class="teacherList" @click="enterDetails(cousrseData)">
          <div>
            <ul v-if="cousrseData.teacherRespVOS">
              <li
                v-for="(teacherItem, teaind) in cousrseData.teacherRespVOS.length > 3
                  ? cousrseData.teacherRespVOS.slice(0, 3)
                  : cousrseData.teacherRespVOS"
                :key="teaind"
              >
                <div class="teabg">
                  <img :src="teacherItem.teacherHead || defaultImg" alt="" />
                </div>
                <p>{{ teacherItem.name }}</p>
              </li>
            </ul>
            <p class="endTime">{{ cousrseData.salesVolume }}人已购买</p>
          </div>

          <!-- 售价 -->
          <div class="coursePriceBox">
            <del v-if="cousrseData.originalPrice">￥{{ cousrseData.originalPrice }}</del>
            <div :class="renderDom() ? 'symbol' : 'normal'">
              <img
                v-if="renderDom()"
                class="start2"
                src="@/assets/img/activity/seconDkill/nostart2.png"
                alt=""
              />
              <div class="coursePrice">
                <span
                  class="courseType"
                  v-if="
                    cousrseData.productDiscountRespVO &&
                    cousrseData.productDiscountRespVO.isGroupDiscount
                  "
                  >拼团价</span
                >
                <span v-else-if="cousrseData.promotionLabel" class="courseType">{{
                  cousrseData.promotionLabel === 1
                    ? '折后价'
                    : cousrseData.promotionLabel === 4
                    ? '券后价'
                    : '限时价'
                }}</span>
                <p class="showPic">
                  <template
                    v-if="
                      cousrseData.productDiscountRespVO &&
                      cousrseData.productDiscountRespVO.isGroupDiscount
                    "
                  >
                    <b>¥</b>
                    <span>{{ cousrseData.productDiscountRespVO.discountMinPrice }}</span>
                  </template>
                  <template v-else>
                    <b
                      v-if="
                        cousrseData.sellPrice === 0 && !cousrseData.promotionLabel ? false : true
                      "
                      >¥</b
                    >
                    <span
                      :class="{
                        fontSty: cousrseData.sellPrice === 0 && !cousrseData.promotionLabel,
                      }"
                      >{{
                        cousrseData.sellPrice === 0 && !cousrseData.promotionLabel
                          ? '限时免费'
                          : cousrseData.sellPrice
                      }}</span
                    >
                  </template>
                </p>
              </div>
            </div>
            <div class="zixunbox" v-if="!renderDom()">
              <div class="zixun" @click="canBuyCourse(cousrseData) ? enterDetails(cousrseData) : openChat()">
                {{ canBuyCourse(cousrseData) ? '立即购买' : '立即咨询' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </div>
</template>

<script>
import canBuyCourse from '@/utils/canBuyCourse';
import wx from 'weixin-js-sdk';
import { replaceHyphens, timerYhqCount } from '@/utils/tools';
import defaultImg from '../../../../assets/img/loginImg/default.png';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultImg,
      cousrseData: {},
      timeCount: 0,
      showCount: false,
      activeStatus: 0
    };
  },
  created() {
    this.cousrseData = this.item.homePageProductWebRespVO;
    this.activeStatus = this.item.status
  },
  mounted() {
    this.handleTime();
  },
  computed: {},
  methods: {
    canBuyCourse,
    renderDom(){
      return (this.cousrseData.productDiscountRespVO.promotionShowTime && ![5,8].includes(this.activeStatus))
    },
    handleTime() {
      let acvitityStartTime = this.cousrseData?.acvitityStartTime;
      if (acvitityStartTime) {
        let serveTime = this.cousrseData?.severTime;
        let time = (new Date(replaceHyphens(acvitityStartTime)).getTime()) - (new Date(replaceHyphens(serveTime)).getTime());
        let difTime =
          new Date(replaceHyphens(acvitityStartTime)).getTime() -
          new Date(replaceHyphens(serveTime)).getTime();
        if (difTime > 0) {
          this.showCount = true;
          this.timeCount = time;
        } else {
          this.showCount = false;
          this.timeCount = 0;
        }
      } else {
        this.showCount = false;
        this.timeCount = 0;
      }
    },

    // 进入详情
    enterDetails(courseInfo) {
      sessionStorage.setItem("back", "true"); //此处是为了返回到上一页  不加会直接返回到官网首页了
      const { productSkipConfigRespVO, productId } = courseInfo;
      // 判断是否App
      if (this.$root.$data.isApp) {
        if (productSkipConfigRespVO?.source === 1 && productSkipConfigRespVO?.skipType === 0) {
          // 外部产品
          this.$sendToApp('openBrowser', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else if (
          // 淘宝产品
          productSkipConfigRespVO?.source === 1 &&
          productSkipConfigRespVO?.skipType === 1
        ) {
          this.$sendToApp('openTaobao', { url: productSkipConfigRespVO?.mobileSkipUrl }, false);
        } else {
          this.$sendToApp('goCourseDetail', Number(productId), false);
        }
        return;
      }
      if (productSkipConfigRespVO?.source === 1) {
        // 外部产品
        window.open(productSkipConfigRespVO?.mobileSkipUrl);
        return;
      }
      const { roomId } = this.$route.query;
      if (roomId) {
        // 直播间内的推荐课程
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
            liveRoomId: roomId,
          },
        });
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: productId,
          },
        });
      }
    },
    supplement(time) {
      return time < 10 ? '0' + time : time;
    },
    openChat() {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: 'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        console.log(1111);
        wx.miniProgram.navigateTo({
          url: '/subPackages/mantisChat/mantisChat',
        });
        return;
      }
      window.open(
        'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
      );
    },
  },
  filters: {
    changeDeadLineTime(value) {
      return value.split(' ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  .showtag {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 30px;
    background: linear-gradient(#fff1f5, #fff);
    border-radius: 14px 14px 0 0;

    .enpty{
      width: 202px;
      height: 60px;
    }
    .difcolor {
      color: #ff5656;
    }

    .days {
      margin: 0 10px;
    }

    img {
      display: block;
      width: 202px;
      height: 60px;
    }
  }
}

.dkillItemBox {
  margin-bottom: 32px;
  padding: 20px 29px 16px 25px;
  background: $bgWhite;
  border-radius: 0 0 14px 14px;
}

.dkillTitle {
  display: -webkit-box;
  overflow: hidden;
  color: $fontColorBlack;
  font-weight: bold !important;
  font-size: 33px;
  line-height: 45px;
  @extend .ellipsis-2;

  // text-overflow: ellipsis;
  // -webkit-line-clamp: 2;
  // -webkit-box-orient: vertical;
  i {
    margin-left: -18px;
  }
}

.activityTag {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 9px 5px 11px 0;
  font-size: 0;

  .tag-component {
    margin-right: 14px;
  }
}

.TimeHours {
  display: flex;
  align-items: center;
  margin-top: 10px;
  line-height: 30px;

  p {
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;
  }

  span {
    margin-left: 12px;
    color: $fontColorGray;
    font-size: 24px;
  }

  em {
    margin-left: 12px;
    font-style: normal;
  }
  .time1 {
    display: flex;
    align-items: flex-start;
    align-items: center;
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;
    img {
      width: 24px;
      margin-right: 5px;
    }
  }
}

.teacherList {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 46px;

  ul {
    display: flex;

    li {
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: center;
      // width: 64px;
      margin-right: 10px;

      .teabg {
        width: 63px;
        height: 63px;
        margin: 0 auto;
        background-color: $teabg;
        border-radius: 50%;

        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      p {
        max-width: 120px;
        margin-top: 9px;
        overflow: hidden;
        color: $fontColorGray;
        font-size: 22px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .endTime {
    margin-top: 18px;
    color: $fontColorGray;
    font-size: 24px;
  }
}

.coursePriceBox {
  del {
    display: inline-block;
    width: 100%;
    color: $delcolor;
    font-size: 24px;
    text-align: right;
  }

  .symbol {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 288px;
    height: 58px;
    line-height: 58px;
    background: linear-gradient(90deg, #ff7f41 0%, #ffd488 100%);
    border-radius: 31px;

    .start2 {
      display: block;
      width: 24px;
      height: 38px;
      margin-right: 10px;
    }
    .coursePrice {
      display: flex;
      align-items: center;

      .courseType {
        color: #fff;
        font-weight: 500;
        font-size: 24px;
      }
    }
    .showPic {
      margin-left: 6px;
      font-weight: bold;
      font-size: 28px;
      text-align: center;

      b {
        margin: 0 4px;
        color: #fff;
        font-size: 28px;
      }

      span {
        color: #fff;
        font-weight: bold;
        font-size: 38px;
      }

      .fontSty {
        font-size: 30px;
      }
    }
  }
  .normal {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 288px;
    height: 58px;
    line-height: 58px;
    .coursePrice {
      display: flex;
      align-items: center;

      .courseType {
        color: #ff3938;
        font-weight: 500;
        font-size: 24px;
      }
    }

    .showPic {
      margin-left: 6px;
      font-weight: bold;
      font-size: 28px;
      text-align: center;

      b {
        margin: 0 4px;
        color: #ff3938;
        font-size: 28px;
      }

      span {
        color: #ff3938;
        font-weight: bold;
        font-size: 38px;
      }

      .fontSty {
        font-size: 30px;
      }
    }
  }
  .zixunbox {
    display: flex;
    justify-content: flex-end;
    .zixun {
      width: 116px;
      height: 34px;
      color: #fff;
      font-weight: 400;
      font-size: 22px;
      line-height: 34px;
      text-align: center;
      background: #ff7f41;
      border-radius: 17px;
    }
  }
}

.showPic {
  margin-left: 6px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;

  b {
    margin: 0 4px;
    color: #fff;
    font-size: 28px;
  }

  span {
    color: #fff;
    font-weight: bold;
    font-size: 38px;
  }

  .fontSty {
    font-size: 30px;
  }
}

.audition {
  position: absolute;
  top: 0;
  right: -37px;
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 18px;
  color: $liveColor;
  font-weight: 500;
  font-size: 24px;
  background: #fef5f1;
  border-radius: 19px 0 0 19px;

  img {
    width: 14px;
    height: 24px;
    margin-left: 10px;
  }
}

.consultBtn {
  width: 128px;
  height: 46px;
  color: #fff;
  font-weight: 400;
  font-size: 24px;
  line-height: 46px;
  text-align: center;
  background: #ff7f41;
  border-radius: 23px;
}
</style>
